var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-feedback-screen-structure',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBaseFeedbackScreen),expression:"showBaseFeedbackScreen"}],attrs:{"animated":_vm.animated,"center-content":_vm.centerContent,"transparent":_vm.transparent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }